var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "currentColor",
    fill: "none",
    height: 17,
    viewBox: "0 0 22 17",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    height: 2,
    rx: 0.5,
    width: 21,
    x: 0.5,
    y: 14.5
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    rx: 2,
    width: 18,
    x: 2,
    y: 1
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.7149 5.37965c.1709.05668.2851.20931.2851.38084v2.50911c0 .70128-.269 1.3707-.7441 1.8893-.239.2612-.5412.4646-.8623.6291l-1.3913.712-1.39359-.7124c-.32143-.1645-.62409-.3675-.8634-.629-.4755-.51867-.74531-1.18846-.74531-1.89048v-2.50763c0-.17153.11418-.32416.28506-.38084l2.57374-.85687c.0915-.03037.1913-.03037.2824 0z",
    fillRule: "evenodd",
    opacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceSvg);
export default __webpack_public_path__ + "static/media/DeviceSVG.f40e2905.svg";
export { ForwardRef as ReactComponent };